// extracted by mini-css-extract-plugin
var _1 = "PostTitleWithIcons-module__icon--Xk_3w";
var _2 = "PostTitleWithIcons-module__regular--kBY9T";
var _3 = "PostTitleWithIcons-module__small--ECwUd";
export { _1 as "icon", _2 as "regular", _3 as "small" }
